import { PRIVATE_ADMIN, PRIVATE_USER } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_USER_ORGCHART = PRIVATE_USER + '/orgchart';
export const PRIVATE_USER_ORGCHART_VACACIONES = PRIVATE_USER + '/orgchart/vacaciones';
export const PRIVATE_USER_ORGCHART_EXTRAS = PRIVATE_USER + '/orgchart/extras';
export const PRIVATE_ADMIN_ORGCHART = PRIVATE_ADMIN + '/orgchart';
export const PRIVATE_ADMIN_ORGCHART_VACACIONES = PRIVATE_ADMIN + '/orgchart/vacaciones';
export const PRIVATE_ADMIN_ORGCHART_EXTRAS = PRIVATE_ADMIN + '/orgchart/extras';